import { atom } from 'recoil';

const tileStyleState = atom({
    key: 'tileStyle',
    default: null
});

export default tileStyleState;
